import React, { useEffect, useRef, useState } from 'react'
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs'
import { useNavigate, useParams } from "react-router-dom"
import AddModel from '../../../components/Add/AddModel'
import TicketHeader from './components/TicketHeader'
import Image from '../../../components/images/Image'
import ViewTicketModal from './components/TicketViewModal'
import ToolTip from '../../../components/ToolTip/ToolTip'
import AudioMessage from './components/AudioMessage'
import { useSelector } from 'react-redux'
import { showToast } from '../../../components/toastMessage/toastSlice'
import config from '../../../config/config'
import { AudioVisualizer } from "react-audio-visualize";
import { formatTime } from '../../../utils/audioUtils'
import RecordingLoader from '../../../components/loaders/RecordingLoader'
import LoadingButton from '../../../components/buttons/LoadingButton'
import fixWebmDuration from "webm-duration-fix";
import useApi from '../../../services/useApi'
import { uploadData } from '@aws-amplify/storage'
import { v4 as uuidv4 } from 'uuid'
import { handleAudioUpload as s3AudioUpload } from '../../../components/S3uploads/S3AudioUploadFunction'
import { useDispatch } from 'react-redux'
import CommonDropdown from '../../../components/Dropdowns/CommonDropdown'
import DropdownItem from '../../../components/Dropdowns/DropdownItem'
import DropdownButtonForSearch from '../../../components/Dropdowns/DropdownButtonForSearch'
import SecondaryButton from '../../../components/buttons/SecondaryButton'
import Button from '../../../components/buttons/Button'
import CustomRadioButton from '../../../components/buttons/CustomRadioButton'
import MentionDropdown from './components/MentionDropdown'
import CustomModal from '../../../components/CustomModal'



const ViewTicket = () => {
    const navigate = useNavigate()
    const [isRecording, setIsRecording] = useState(false);
    const [isRecorded, setIsRecorded] = useState(false);
    const [recordedBlob, setRecordedBlob] = useState<Blob | null>(null);
    const [viewRecordedBlob, setViewRecordedBlob] = useState<Blob | null>(null);
    const [visualizerWidth, setVisualizerWidth] = useState<number>(300)
    const [duration, setDuration] = useState("00:00")

    const [isPlaying, setIsPlaying] = useState(false);
    const [timer, setTimer] = useState(0);
    const [showModal, setShowModal] = useState(false)
    const [ticketDetails, setTicketDetails] = useState({})

    //states for comments
    const [inputMessage, setInputMessage] = useState("");
    const [ticketMessages, setTicketMessages] = useState<any[]>([]);
    const currentUserId = useSelector(state => state?.userEmail?.loggedUserId);
    const { userInfo } = useSelector(state => state?.userEmail)


    const [page, setPage] = useState(1);
    const messagesEndRef = useRef(null);
    const messagesContainerRef = useRef<HTMLDivElement>(null);
    const [loadingMessages, setLoadingMessages] = useState(true);
    const [totalPages, setTotalPages] = useState<number>(Infinity); // default to very high initially
    const [firstTimeLoad, setFirstTimeLoad] = useState(true);
    const [sendingSms, setSendingSms] = useState(false);
    const [playedTime, setPlayedTime] = useState(0);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedPriority, setSelectedPriority] = useState('');
    const [showCloseModal, setShowCloseModal] = useState(false);
    const [messageType, setMessageType] = useState('normal');
    const [showMentionDropdown, setShowMentionDropdown] = useState(false);
    const [mentionUsers, setMentionUsers] = useState<any[]>([]);
    const [mentionQuery, setMentionQuery] = useState('');
    const [cursorPosition, setCursorPosition] = useState(0);
    const debounceRef = useRef<NodeJS.Timeout | null>(null);
    const [mentions, setMentions] = useState<Array<{ start: number, end: number, name: string, userCode: string }>>([]);
    const [selectedMentionIndex, setSelectedMentionIndex] = useState(-1);
    const [loadingMentions, setLoadingMentions] = useState(false);
    const [actionLoading, setActionLoading] = useState<"assign" | "close" | null>(null);
    const [showCloseConfirmModal, setShowCloseConfirmModal] = useState(false);

    // Assignee state
    const [assigneeOptions, setAssigneeOptions] = useState<{ label: string; value: string }[]>([]);
    const [selectedAssignee, setSelectedAssignee] = useState<string | undefined>();
    const [assigneePage, setAssigneePage] = useState(1);
    const [loadingAssignees, setLoadingAssignees] = useState(false);

    // Ticket management states
    const [status, setStatus] = useState<string>('');
    const [priority, setPriority] = useState<string>('');
    const [assignee, setAssignee] = useState<{ id: string; label: string } | null>(null);

    // Track original values to detect changes
    const [originalPriority, setOriginalPriority] = useState<string>('');
    const [originalAssignee, setOriginalAssignee] = useState<{ id: string; label: string } | null>(null);

    const dispatch = useDispatch();
    const { getAPI, PostAPI } = useApi();
    const { ticketId } = useParams();
    const waveformRef = useRef<HTMLDivElement | null>(null);
    const mediaRecorderRef = useRef<MediaRecorder | null>(null);
    const audioChunks = useRef<Blob[]>([]);
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const audioRef = useRef<HTMLAudioElement | null>(null)
    const [currentTime, setCurrentTime] = useState();
    const visualizerContainerRef = useRef<HTMLDivElement>(null)
    const fileInputRef = useRef<HTMLInputElement>(null);
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    //states for voice
    const [audioStream, setAudioStream] = useState<MediaStream | null>(null);
    const visualizerRef = useRef<HTMLCanvasElement | null>(null);
    const [isStreamReady, setIsStreamReady] = useState(false);
    const isCancelledRef = useRef(false);


    //states for the doc upload
    const [uploadedFile, setUploadedFile] = useState<File | null>(null);
    const [uploadedFilePreview, setUploadedFilePreview] = useState<string | null>(null);
    const [isUploadingFile, setIsUploadingFile] = useState(false);

    // File upload handler using AWS Amplify
    const handleUpload = async (file: File, UploadPath: string): Promise<string | null> => {
        const fileName = file.name;
        const key = `${UploadPath}/${uuidv4()}/${fileName}`;

        try {
            const result = await uploadData({
                key: key,
                data: file,
                options: {
                    contentType: file.type,
                    accessLevel: 'guest',
                },
            });

            const urlKey = await result.result;
            if (urlKey) {
                return urlKey.key;
            }
            throw new Error('Unexpected upload result format');
        } catch (error) {
            console.error('Upload Error:', error);
            dispatch(showToast({ type: "error", message: "File upload failed" }));
            return null;
        }
    };


    const handleTicketUpdate = async (action: "assign" | "close") => {
        try {
            setActionLoading(action); // start loading

            // base payload
            const payload: any = {
                ticket_id: ticketId,
                assignee_user_id: assignee?.value,
                priority: priority || "Medium",
            };

            if (action === "close") {
                payload.status = "Closed";
            }

            const response = await PostAPI("admin-support", payload);

            if (!response.error) {
                const successMsg =
                    action === "close"
                        ? "Ticket closed successfully!"
                        : "Ticket assigned successfully!";

                dispatch(showToast({ type: "success", message: successMsg }));
                fetchTicketDetails(1);
                
                // Clear message input after successful assignment
                if (action === "assign") {
                    setInputMessage("");
                    if (textareaRef.current) {
                        textareaRef.current.innerHTML = '';
                        textareaRef.current.innerText = '';
                    }
                }
            } else {
                throw new Error(response?.data?.message || "Failed to update ticket");
            }
        } catch (err) {
            console.error("Ticket update error:", err);
            const errorMsg =
                action === "close"
                    ? "Failed to close ticket."
                    : "Failed to assign ticket.";
            dispatch(showToast({ type: "error", message: errorMsg }));
        } finally {
            setActionLoading(null); // stop loading
        }
    };

    let activeAssigneeCall = 0;

    const fetchAssignees = async (search: string = "", isPageChange = false) => {
        const callId = ++activeAssigneeCall;
        try {
            setLoadingAssignees(true);
            const pageToFetch = isPageChange ? assigneePage + 1 : 1;

            const endpoint = `admin-support/assigee?page_number=${pageToFetch}&search=${encodeURIComponent(search)}`;
            const response = await getAPI(endpoint);

            if (callId !== activeAssigneeCall) return;

            if (!response.error && response?.data?.data?.assigees) {
                const apiOptions = response.data.data.assigees.map((item: any) => ({
                    label: `${item.first_name}${item.last_name ? ` ${item.last_name}` : ''} (${item.user_code})`,
                    value: item.id,
                }));

                if (isPageChange) {
                    setAssigneeOptions(prev => [...prev, ...apiOptions]);
                    setAssigneePage(pageToFetch);
                } else {
                    // Add "Assign to Me" option only at the beginning of first page
                    const assignToMeOption = {
                        label: "Assign to Self",
                        value: currentUserId,
                    };
                    setAssigneeOptions([assignToMeOption, ...apiOptions]);
                    setAssigneePage(1);
                }
            }
        } catch (error) {
            console.error("Error fetching assignees:", error);
        } finally {
            if (callId === activeAssigneeCall) {
                setLoadingAssignees(false);
            }
        }
    };


    // Audio upload handler using S3AudioUploadFunction
    const handleAudioUpload = async (blob: Blob, UploadPath: string): Promise<string | null> => {
        try {
            const result = await s3AudioUpload(blob, UploadPath, 'support-audio');
            if (result) {
                return result;
            }
            throw new Error('Audio upload failed');
        } catch (error) {
            console.error('Audio Upload Error:', error);
            dispatch(showToast({ type: "error", message: "Audio upload failed" }));
            return null;
        }
    };


    const isUserAssigned = ticketDetails?.assignee_user_id === currentUserId;
    const isInteractionDisabled = isRecording || isRecorded || uploadedFile || isUploadingFile || !isUserAssigned;


    const fetchTicketDetails = async (pageToLoad = 1, isPrepend = false) => {
        try {
            setLoadingMessages(true);

            const endpoint = `admin-support/${ticketId}`;
            const response = await getAPI(endpoint);

            if (response?.error) {
                if (response?.status === 404 || response?.message?.includes('not found') || response?.message?.includes('Not Found')) {
                    navigate('/404');
                    return;
                }
                throw new Error(response?.message || 'Unknown error while fetching messages');
            }

            const { ticket_data, ticket_messages = [], total_messages = 0, page_size = 20 } = response.data || {};

            // Set ticket details only on first page
            if (pageToLoad === 1 || firstTimeLoad) {
                setTicketDetails(ticket_data || {});
            }

            // Compute pagination
            const computedTotalPages = Math.ceil(total_messages / page_size);
            setTotalPages(computedTotalPages);

            const reversedMessages = ticket_messages.reverse();

            setTicketMessages(prevMessages =>
                isPrepend
                    ? [...reversedMessages, ...prevMessages]
                    : pageToLoad === 1
                        ? reversedMessages
                        : [...prevMessages, ...reversedMessages]
            );

            setPage(pageToLoad);
            if (firstTimeLoad) setFirstTimeLoad(false);
        } catch (error) {
            console.error("Error fetching ticket details:", error);
            navigate('/404');
        } finally {
            setLoadingMessages(false);
        }
    };

    useEffect(() => {
        const container = messagesContainerRef.current;
        if (!container) return;

        const handleScroll = () => {
            if (
                container.scrollTop === 0 &&
                !loadingMessages &&
                page < totalPages
            ) {
                const previousHeight = container.scrollHeight;

                fetchTicketDetails(page + 1, true).then(() => {
                    setTimeout(() => {
                        container.scrollTop = container.scrollHeight - previousHeight;
                    }, 100);
                });
            }
        };

        container.addEventListener("scroll", handleScroll);
        return () => container.removeEventListener("scroll", handleScroll);
    }, [page, loadingMessages, totalPages]);


    useEffect(() => {
        fetchTicketDetails(1);
    }, []);

    // Clear message input when ticket is closed
    useEffect(() => {
        if (ticketDetails?.status === "Closed") {
            setInputMessage("");
            if (textareaRef.current) {
                textareaRef.current.innerHTML = '';
                textareaRef.current.innerText = '';
            }
        }
    }, [ticketDetails?.status]);

    // Initialize priority and assignee when ticket details are loaded
    useEffect(() => {
        if (ticketDetails?.priority) {
            setPriority(ticketDetails.priority);
            setOriginalPriority(ticketDetails.priority);
        }
        if (ticketDetails?.assignee_user_id && ticketDetails?.assignee_first_name && ticketDetails?.assignee_last_name && ticketDetails?.assignee_user_code) {
            const isAssignedToSelf = userInfo?.user_code === ticketDetails.assignee_user_code;
            const assigneeData = {
                id: ticketDetails.assignee_user_id,
                label: isAssignedToSelf ? "Assign to Self" : `${ticketDetails.assignee_first_name} ${ticketDetails.assignee_last_name} (${ticketDetails.assignee_user_code})`
            };
            setAssignee(assigneeData);
            setOriginalAssignee(assigneeData);
        }
    }, [ticketDetails, userInfo?.user_code]);

    useEffect(() => {
        // Scroll to bottom when messages change
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [ticketMessages]);


    const handleSendMessage = async () => {
        let audioKey = null;
        let fileKey = null;
        setSendingSms(true);

        if (recordedBlob) {
            audioKey = await handleAudioUpload(recordedBlob, "uploads/support-ticket");
            if (!audioKey) {
                setSendingSms(false);
                return;
            }
        }

        if (uploadedFile) {
            setIsUploadingFile(true);
            fileKey = await handleUpload(uploadedFile, "uploads/support-ticket");
            setIsUploadingFile(false);
            if (!fileKey) {
                setSendingSms(false);
                return;
            }
        }

        // Get the actual content from contentEditable div
        const actualContent = getFullTextContent();
        
        if (!actualContent.trim() && !recordedBlob && !uploadedFile) {
            setSendingSms(false);
            return;
        }

        if (actualContent.length > 2000) {
            dispatch(showToast({ type: "error", message: "Message cannot exceed 2000 characters." }));
            setSendingSms(false);
            return;
        }

        // Extract @ mentions from contentEditable div and get message with delimiters
        const mentionIds = extractMentionsFromDiv();
        const messageWithDelimiters = getMessageWithDelimiters();

        try {
            const payload = {
                ticket_id: ticketId,
                sender_id: userInfo?.id || currentUserId,
                sender_name: userInfo?.full_name || `${userInfo?.first_name || ''} ${userInfo?.last_name || ''}`.trim() || 'Admin User',
                sender_type: "ADM",
                receiver_id: ticketDetails?.user_id,
                reciever_name: ticketDetails?.full_name,
                receiver_type: ticketDetails?.user_type,
                message_type: messageType,
                ...(messageType === 'internal' && mentionIds.length > 0 && { tagged_user_ids: mentionIds }),
                messages: messageWithDelimiters || inputMessage || "",
                audio: audioKey || "",
                file: fileKey || ""
            };


            const response = await PostAPI("admin-support/comment", payload);

            if (!response.error) {
                const newMessage = {
                    ...response?.data?.data,
                    is_internal: messageType === 'internal'
                };
                setTicketMessages(prev => [...prev, newMessage]);
                setInputMessage("");
                setMentions([]);
                if (textareaRef.current) {
                    textareaRef.current.innerHTML = '';
                    textareaRef.current.innerText = '';
                }
                setRecordedBlob(null);
                setViewRecordedBlob(null);
                setIsRecorded(false);
                setIsRecording(false);
                setTimer(0);
                resetUploadedFile();
                audioChunks.current = [];
                setIsPlaying(false);

                if (audioRef.current) {
                    audioRef.current.pause();
                    audioRef.current.src = '';
                }


            } else {
                dispatch(showToast({
                    type: "error",
                    message: response?.data?.message || response?.message || "Failed to send message"
                }));
            }
        } catch (error) {
            console.error("Error sending message:", error);
            dispatch(showToast({ type: "error", message: "Something went wrong while sending message" }));
        } finally {
            setSendingSms(false);
        }
    };


    const formatDateTime = (dateStr: string) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;

        return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
    };

    const getInitials = (name: string) => {
        if (!name) return 'ZP';
        const words = name.trim().split(' ');
        if (words.length >= 2) {
            return (words[0][0] + words[1][0]).toUpperCase();
        }
        return words[0][0].toUpperCase();
    };

    const renderMessageWithMentions = (messageText: string, msg: any) => {
        if (!msg.tagged_user_ids || msg.tagged_user_ids.length === 0) {
            return messageText;
        }

        // Use delimiter pattern to match mentions: <<@UserName>>
        const mentionRegex = /<<@[^>]+>>/g;
        const parts = [];
        let lastIndex = 0;
        let match;

        while ((match = mentionRegex.exec(messageText)) !== null) {
            // Add text before the mention
            if (match.index > lastIndex) {
                parts.push({
                    type: 'text',
                    content: messageText.substring(lastIndex, match.index)
                });
            }
            
            // Add the mention (remove delimiters for display)
            const mentionText = match[0].replace(/<<|>>/g, '');
            parts.push({
                type: 'mention',
                content: mentionText
            });
            
            lastIndex = match.index + match[0].length;
        }
        
        // Add remaining text after the last mention
        if (lastIndex < messageText.length) {
            parts.push({
                type: 'text',
                content: messageText.substring(lastIndex)
            });
        }

        return (
            <>
                {parts.map((part, index) => (
                    <React.Fragment key={index}>
                        {part.type === 'mention' ? (
                            <span className="bg-white px-1 py-0.5 rounded shadow-sm text-primary_text">
                                {part.content}
                            </span>
                        ) : (
                            part.content
                        )}
                    </React.Fragment>
                ))}
            </>
        );
    };


    const renderIndividualMessages = (messages: any[], currentUserId: string) => {
        return messages.map((msg, i) => {
            const isMine = msg.sender_id === currentUserId;

            return (
                <div key={i} className={`mb-6 flex flex-col ${isMine ? 'items-end' : 'items-start'}`}>
                    {/* Sender name & time */}
                    <div className={`text-subTitle text-primary_text mb-1 ${isMine ? "mr-[90px]" : "ml-[77px]"}`}>
                        <span>{`${msg.sender_name || '-'}(${isMine ? userInfo?.user_code || '-' : ticketDetails?.user_code || '-'}) `}</span>
                        <span className="text-subTitle text-secondary_text text-nowrap">{formatDateTime(msg.created_at || '')}</span>
                    </div>

                    <div className="flex gap-4">
                        {/* Avatar on left (for others) */}
                        {!isMine && (
                            <div className="w-11 mr-2">
                                {msg.sender_photo ? (
                                    <img
                                        src={`${config.cdnURL}public/${msg.sender_photo}`}
                                        className="w-11 h-9 rounded-[8px] object-cover border"
                                    />
                                ) : (
                                    <div className="w-11 h-9 rounded-[8px] bg-p_primary text-white flex items-center justify-center text-sm font-medium border">
                                        {getInitials(msg.sender_name || msg.sender_first_name + ' ' + msg.sender_last_name || 'Admin')}
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="flex flex-col gap-2 max-w-[750px]">
                            {/* Text message */}
                            {msg.messages && (
                                <div
                                    className={`text-wrap px-4 py-2 rounded-lg text-sm break-all ${(msg.message_type === 'internal' || msg.is_internal) && msg.tagged_user_ids && msg.tagged_user_ids.includes(currentUserId)
                                        ? 'bg-white border border-p_primary text-secondary_text self-start'
                                        : (msg.message_type === 'internal' || msg.is_internal)
                                            ? 'bg-[#B8C9E3] text-[#0E3671] text-subTitle self-end'
                                            : isMine
                                                ? 'bg-background_blue text-secondary_text self-end'
                                                : 'bg-background_blue text-secondary_text self-start'
                                        }`}
                                >
                                    <p className="whitespace-pre-wrap">{renderMessageWithMentions(msg.messages, msg)}</p>
                                </div>
                            )}

                            {/* Audio message as a separate block */}
                            {msg.audio && (
                                <div className={`self-${isMine ? 'end' : 'start'}`}>
                                    <AudioMessage audioKey={msg.audio} />
                                </div>
                            )}

                            {/* File attachment message */}
                            {msg.file && (
                                <div className={`self-${isMine ? 'end' : 'start'} right-[-30px]`}>
                                    <div className="w-[340px] flex justify-between gap-1 overflow-hidden text-ellipsis py-[15px] px-[18px] bg-outline rounded-[8px] text-body1">
                                        <a
                                            href={(() => {
                                                const filePath = msg.file || '';
                                                const path = filePath.startsWith('public/') ? filePath : `public/${filePath}`;
                                                const baseUrl = config?.cdnURL || config?.baseURL || '';
                                                const normalizedBaseUrl = baseUrl ? baseUrl.replace(/\/$/, '') + '/' : '';
                                                const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
                                                return normalizedBaseUrl + normalizedPath;
                                            })()}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="truncate max-w-[200px] hover:underline"
                                        >
                                            {msg.file?.split('/').pop() || '-'}
                                        </a>
                                        <ToolTip ToolTipItem={msg.file?.split('/').pop() || '-'} top="top-0" />
                                        <Image
                                            src="file-eye" // Replace with appropriate icon or type-based logic
                                            className="w-5 h-5 cursor-pointer"
                                            onClick={() => {
                                                const filePath = msg.file || '';
                                                if (!filePath) return;
                                                const path = filePath.startsWith('public/') ? filePath : `public/${filePath}`;
                                                const baseUrl = config?.cdnURL || config?.baseURL || '';
                                                const normalizedBaseUrl = baseUrl ? baseUrl.replace(/\/$/, '') + '/' : '';
                                                const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
                                                const fileUrl = normalizedBaseUrl + normalizedPath;
                                                window.open(fileUrl, "_blank");
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Avatar on right (for me) */}
                        {isMine && (
                            <div className="w-11 ml-2 mr-5 ">
                                {userInfo?.photo ? (
                                    <img
                                        src={`${config.cdnURL}public/${userInfo.photo}`}
                                        className="w-10 h-10 rounded-[8px] object-cover border"
                                    />
                                ) : (
                                    <div className="w-10 h-10 rounded-[8px] bg-secondary text-white flex items-center justify-center text-sm font-medium border">
                                        {getInitials(userInfo?.first_name + ' ' + userInfo?.last_name)}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    };

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            await new Promise(resolve => setTimeout(resolve, 100));
            setAudioStream(stream);
            setIsStreamReady(true);

            const mediaRecorder = new MediaRecorder(stream);
            mediaRecorderRef.current = mediaRecorder;
            audioChunks.current = [];

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    audioChunks.current.push(event.data);
                    // Removed size limit logic
                }
            };

            mediaRecorder.onstop = async () => {
                if (isCancelledRef.current) {
                    isCancelledRef.current = false;
                    return;
                }

                const rawBlob = new Blob(audioChunks.current, { type: "audio/webm" });
                const fixedBlob = await fixWebmDuration(rawBlob, timer);

                setRecordedBlob(fixedBlob);
                setViewRecordedBlob(fixedBlob);
                setIsRecorded(true);
                setIsRecording(false);
                setIsStreamReady(false);
                audioChunks.current = [];

                // audioStream?.getTracks().forEach((track) => track.stop());
                // setAudioStream(null);
            };

            mediaRecorder.start();
            setIsRecording(true);
            setTimer(0);

            // 5-minute limit
            timerRef.current = setInterval(() => {
                setTimer((prev) => {
                    const newTime = prev + 1;
                    if (newTime >= 300) {
                        dispatch(showToast({ type: "info", message: "Maximum recording duration reached (5 minutes)." }));
                        if (mediaRecorderRef.current?.state === "recording") {
                            mediaRecorderRef.current.stop();
                        }
                        clearInterval(timerRef.current!);
                    }
                    return newTime;
                });
            }, 1000);
        } catch (err) {
            console.error("Microphone access error:", err);
            dispatch(showToast({ type: "error", message: "Microphone access denied." }));
            setIsStreamReady(false);
            setAudioStream(null);
        }
    };

    const handleCancelRecording = () => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state === "recording") {
            isCancelledRef.current = true;
            mediaRecorderRef.current.stop();
        }
        if (audioStream) {
            audioStream.getTracks().forEach((track) => track.stop());
        }

        setIsRecording(false);
        setIsRecorded(false);
        setAudioStream(null);
        setIsStreamReady(false);
        audioChunks.current = [];
        setRecordedBlob(null);
        setTimer(0);

        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
    };


    const handleStopRecording = () => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state === "recording") {
            mediaRecorderRef.current.stop();
        }
        if (audioStream) {
            audioStream.getTracks().forEach((track) => track.stop());
            setAudioStream(null); // also clear from state
        }
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
    };

    const handlePlayPauseRecordedAudio = () => {
        const audio = audioRef.current;
        if (!audio) return;

        if (audio.paused) {
            audio.play();
            setIsPlaying(true);
        } else {
            audio.pause();
            setIsPlaying(false);
        }

        // Track live played time
        audio.ontimeupdate = () => {
            setPlayedTime(audio.currentTime);
        };

        // Reset when ended
        audio.onended = () => {
            setIsPlaying(false);
            setPlayedTime(0);
        };
    };



    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (file.size > 10 * 1024 * 1024) {
            dispatch(showToast({ type: "error", message: "File size must be under 10MB." }));
            return;
        }

        setUploadedFile(file);

        const fileType = file.type;

        if (fileType.startsWith("image/")) {
            const preview = URL.createObjectURL(file);
            setUploadedFilePreview(preview);
        } else {
            setUploadedFilePreview(null);
        }
    };

    const resetUploadedFile = () => {
        setUploadedFile(null);
        setUploadedFilePreview(null);
        // Reset the file input using ref
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    // Fetch assignees for @ mentions
    const fetchMentionUsers = async (query: string) => {
        try {
            setLoadingMentions(true);
            const response = await getAPI(`admin-support/assigee?search=${query}&page_number=1`);
            if (!response.error && response?.data?.data?.assigees) {
                const users = response.data.data.assigees;
                setMentionUsers(users);
            } else {
                setMentionUsers([]);
            }
        } catch (error) {
            console.error('Error fetching assignees:', error);
            setMentionUsers([]);
        } finally {
            setLoadingMentions(false);
        }
    };

    // Extract mentions from contentEditable div
    const extractMentionsFromDiv = () => {
        if (!textareaRef.current) return [];
        const mentionSpans = textareaRef.current.querySelectorAll('[data-user-id]');
        return Array.from(mentionSpans).map(span => span.getAttribute('data-user-id')).filter(Boolean);
    };

    // Get the full text content including mentions
    const getFullTextContent = () => {
        if (!textareaRef.current) return '';
        return textareaRef.current.innerText || textareaRef.current.textContent || '';
    };

    // Convert mentions to delimiter format for storage
    const getMessageWithDelimiters = () => {
        if (!textareaRef.current) return '';
        
        let messageText = '';
        const childNodes = textareaRef.current.childNodes;
        
        for (let node of childNodes) {
            if (node.nodeType === Node.TEXT_NODE) {
                messageText += node.textContent;
            } else if (node.nodeType === Node.ELEMENT_NODE && node.getAttribute('data-user-id')) {
                // Convert mention to delimiter format for storage
                const mentionText = node.textContent;
                messageText += `<<${mentionText}>>`;
            }
        }
        
        return messageText;
    };

    // Handle mention selection
    const handleMentionSelect = (user: any) => {
        if (!textareaRef.current) return;
        
        const mentionSpan = document.createElement('span');
        mentionSpan.className = 'bg-white px-1 py-0.5 rounded text-primary_text shadow-sm inline-block mr-1';
        mentionSpan.setAttribute('data-user-id', user.id);
        mentionSpan.setAttribute('contenteditable', 'false');
        // Display normal @UserName in UI
        mentionSpan.textContent = `@${user.first_name} ${user.last_name}`;
        
        // Find the @ symbol in the current text
        const text = textareaRef.current.innerText;
        const atIndex = text.lastIndexOf('@');
        
        if (atIndex !== -1) {
            // Clear the content and rebuild it
            const beforeAt = text.substring(0, atIndex);
            const afterQuery = text.substring(text.indexOf(' ', atIndex) !== -1 ? text.indexOf(' ', atIndex) : text.length);
            
            textareaRef.current.innerHTML = '';
            
            if (beforeAt) {
                textareaRef.current.appendChild(document.createTextNode(beforeAt));
            }
            
            textareaRef.current.appendChild(mentionSpan);
            
            const spaceNode = document.createTextNode(' ' + afterQuery);
            textareaRef.current.appendChild(spaceNode);
            
            // Set cursor after the mention
            const range = document.createRange();
            const selection = window.getSelection();
            range.setStart(spaceNode, 1);
            range.setEnd(spaceNode, 1);
            selection?.removeAllRanges();
            selection?.addRange(range);
        }
        
        setShowMentionDropdown(false);
        textareaRef.current.focus();
    };







    useEffect(() => {
        if (recordedBlob && audioRef.current) {
            const objectUrl = URL.createObjectURL(recordedBlob);
            audioRef.current.src = objectUrl;
            audioRef.current.load(); // force reload
        }
    }, [recordedBlob]);

    const addButtonClick = () => {
        navigate('/support/raise-ticket')
    }

    const ticketManagementOptions = ['In Progress', 'Closed'];
    const PriorityLevel = ['Low', 'Medium', 'High'];


    return (
        <div className=''>
            <Breadcrumbs
                navPath={["Support", "Raised Tickets", "View Ticket Details"]}
                heading="View Ticket Details"
                links={["/support/list-tickets", "/support/list-tickets", ""]}
            />

            <AddModel ModelHight="h-maintableheight2">
                <div className="flex flex-col h-full max-h-full scrollBar overflow-auto">
                    {/* Full width ticket header */}
                    <div className="flex-shrink-0">
                        <TicketHeader setShowModal={setShowModal} ticketDetails={ticketDetails} firstTimeLoad={firstTimeLoad} loading={loadingMessages} />
                    </div>

                    {/* Chat and Management sections */}
                    <div className=" w-full gap-4 flex min-h-0">
                        <div className="flex flex-col h-full min-h-0 w-[60%] lg:w-[65%] xl:w-[75%]">
                            <div className="flex-shrink-0 pt-4 pb-2">
                                <h1 className="text-heading3">Comments</h1>
                            </div>

                            <div className="flex-1 overflow-auto ">
                                <div className="flex flex-col h-full">
                                    <div className="flex-1 overflow-y-auto scrollBar pb-5 mb-4">
                                        <div
                                            className="bg-white h-full"
                                            ref={messagesContainerRef}
                                        >
                                            {loadingMessages && <LoadingButton />}
                                            {
                                                ticketMessages.length === 0 && !loadingMessages &&

                                                <div className="flex flex-col text-center justify-center items-center">
                                                    <img src="/images/comments-disabled.png" alt="disabled-icon" />
                                                    <h1 className="text-heading3 mt-9">There are no comments added yet</h1>
                                                    <p className="text-body2 text-secondary_text mt-1">You may start the conversation by adding a comment</p>

                                                </div>
                                            }
                                            {renderIndividualMessages([...ticketMessages], currentUserId)}
                                            <div ref={messagesEndRef} />
                                        </div>
                                    </div>

                                    {/* Fixed message input area */}
                                    <div className={`bg-white pt-2 border-t relative ${!isUserAssigned || ticketDetails?.status === "Closed" ? 'opacity-50 pointer-events-none' : ''}`}>
                                        {/* Message type selection */}
                                        <div className="mb-3">
                                            <CustomRadioButton
                                                options={[
                                                    { id: 'internal', label: 'Add Internal Note' },
                                                    { id: 'normal', label: 'Reply to Customer' }
                                                ]}
                                                selected={ticketDetails?.status === "Closed" ? '' : messageType}
                                                onChange={isUserAssigned && ticketDetails?.status !== "Closed" ? setMessageType : () => {}}
                                                gapClassName="gap-6"
                                                padding="p-0"
                                            />
                                        </div>
                                            {/* Input and send section */}
                                            <div className="flex items-end gap-4">
                                                <div className="flex-1 relative">
                                                    {/* Audio preview block */}
                                                    {isRecorded && recordedBlob ? (
                                                        <div className="flex justify-end">
                                                            <div className="flex items-center gap-2 justify-end bg-white py-2 rounded-lg w-full">
                                                                {/* Play button */}
                                                                <button onClick={handlePlayPauseRecordedAudio}>

                                                                    {isPlaying ? (
                                                                        <Image src="pause" className="h-5 w-4" />
                                                                    ) : (
                                                                        <Image src="play" />
                                                                    )}
                                                                </button>

                                                                {/* Audio visualizer */}
                                                                <AudioVisualizer
                                                                    ref={visualizerRef}
                                                                    blob={recordedBlob}
                                                                    width={200}
                                                                    height={62}
                                                                    barWidth={1}
                                                                    gap={1}
                                                                    barColor={'#000000'}
                                                                    barPlayedColor={'#d92316'}
                                                                // currentTime={playedTime}
                                                                />

                                                                {/* Duration */}
                                                                <span className="text-sm text-gray-600 w-[60px] text-center">{isPlaying ? formatTime(Math.floor(playedTime)) : formatTime(timer)}</span>

                                                                {/* Cancel */}
                                                                <Image src="rounded-close" className="cursor-pointer" onClick={handleCancelRecording} />

                                                                {/* Hidden audio element */}
                                                                <audio ref={audioRef} hidden />
                                                            </div>
                                                        </div>
                                                    ) : isRecording && (
                                                        <div className="flex justify-end h-[78px]">
                                                            {/* recording indicator */}
                                                            <div className="flex items-center justify-end w-full">
                                                                <div className="flex items-center gap-2 ml-2">
                                                                    {audioStream && (
                                                                        <div className="flex items-center">
                                                                            <RecordingLoader />
                                                                        </div>
                                                                    )}
                                                                    <span className="text-gray-600 text-sm w-[50px] text-center">
                                                                        {formatTime(timer)}
                                                                    </span>
                                                                    <button
                                                                        className="w-6 h-6 rounded-full bg-blue-700 flex items-center justify-center" data-testid="pause"
                                                                        onClick={handleStopRecording}
                                                                    >
                                                                        <div className="w-2 h-2 bg-white" />
                                                                    </button>
                                                                    <button
                                                                        className="w-8 h-8  flex items-center justify-center text-gray-500 hover:text-gray-700"
                                                                        onClick={handleCancelRecording}
                                                                    >
                                                                        <Image src="rounded-close" className="cursor-pointer" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* File preview block */}
                                                    {uploadedFile && (
                                                        <div className="flex w-full items-center justify-end gap-4 bg-white py-2 rounded-lg">
                                                            <div className="flex-1 max-w-[300px] flex justify-between gap-1 overflow-hidden text-ellipsis py-[15px] px-[18px] bg-outline mt-2 rounded-[8px] text-body1" data-testid="employee-id-front-container">
                                                                <p title={uploadedFile?.name || '-'} className="more-lines" data-testid="employee-id-front-filename">{uploadedFile?.name}</p>
                                                                <ToolTip ToolTipItem={uploadedFile?.name || ''} top="top-0" />
                                                                <Image
                                                                    src="close"
                                                                    className="cursor-pointer"
                                                                    objectFit="contain"
                                                                    testId="employee-id-card-front-page-image"
                                                                    onClick={() => resetUploadedFile()}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="relative">
                                                        {/* Simple mention highlights */}
                                                        {messageType === 'internal' && mentions.length > 0 && (
                                                            <div className="absolute inset-0 py-5 px-4 leading-[1.6rem] min-h-[48px] max-h-[120px] pointer-events-none whitespace-pre-wrap break-words z-0 overflow-hidden">
                                                                <span className="text-transparent">
                                                                    {inputMessage.split('').map((char, index) => {
                                                                        const mention = mentions.find(m => index >= m.start && index < m.end);
                                                                        return mention ? (
                                                                            index === mention.start ? (
                                                                                <span key={index} className="bg-blue-100 px-1 py-0.5 rounded border border-blue-200 text-transparent">
                                                                                    {inputMessage.substring(mention.start, mention.end)}
                                                                                </span>
                                                                            ) : null
                                                                        ) : (
                                                                            <span key={index}>{char}</span>
                                                                        );
                                                                    })}
                                                                </span>
                                                            </div>
                                                        )}

                                                        <div
                                                            ref={textareaRef}
                                                            contentEditable={isUserAssigned && ticketDetails?.status !== "Closed"}
                                                            suppressContentEditableWarning={true}
                                                            style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap' }}

                                                            onInput={(e) => {
                                                                let text = e.target.innerText;
                                                                // Only clean spaces if there's actual content, preserve single leading space during typing
                                                                if (text.length > 1) {
                                                                    text = text.replace(/^\s+/, '').replace(/\s{2,}/g, ' ');
                                                                }
                                                                if (text.length <= 2000) {
                                                                    setInputMessage(text);
                                                                    
                                                                    if (messageType === 'internal') {
                                                                        const selection = window.getSelection();
                                                                        const range = selection.getRangeAt(0);
                                                                        const currentNode = range.startContainer;
                                                                        
                                                                        // Only trigger @ search if we're in a text node (not inside a mention span)
                                                                        if (currentNode.nodeType === Node.TEXT_NODE) {
                                                                            const textContent = currentNode.textContent;
                                                                            const cursorPos = range.startOffset;
                                                                            const textBeforeCursor = textContent.substring(0, cursorPos);
                                                                            const atIndex = textBeforeCursor.lastIndexOf('@');
                                                                            
                                                                            if (atIndex !== -1) {
                                                                                const textAfterAt = textBeforeCursor.substring(atIndex + 1);
                                                                                if (!textAfterAt.includes(' ') && textAfterAt.length >= 0) {
                                                                                    setShowMentionDropdown(true);
                                                                                    setSelectedMentionIndex(-1);
                                                                                    if (debounceRef.current) clearTimeout(debounceRef.current);
                                                                                    debounceRef.current = setTimeout(() => fetchMentionUsers(textAfterAt), 500);
                                                                                } else {
                                                                                    setShowMentionDropdown(false);
                                                                                }
                                                                            } else {
                                                                                setShowMentionDropdown(false);
                                                                            }
                                                                        } else {
                                                                            setShowMentionDropdown(false);
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (showMentionDropdown && (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter')) {
                                                                    e.preventDefault();
                                                                    if (e.key === 'ArrowDown') {
                                                                        setSelectedMentionIndex(prev => prev < mentionUsers.length - 1 ? prev + 1 : 0);
                                                                    } else if (e.key === 'ArrowUp') {
                                                                        setSelectedMentionIndex(prev => prev > 0 ? prev - 1 : mentionUsers.length - 1);
                                                                    } else if (e.key === 'Enter' && selectedMentionIndex >= 0) {
                                                                        const user = mentionUsers[selectedMentionIndex];
                                                                        const mentionSpan = document.createElement('span');
                                                                        mentionSpan.className = 'bg-white px-1 py-0.5 rounded text-primary_text shadow-sm inline-block mr-1';
                                                                        mentionSpan.setAttribute('data-user-id', user.id);
                                                                        mentionSpan.setAttribute('contenteditable', 'false');
                                                                        // Display normal @UserName in UI
                                                                        mentionSpan.textContent = `@${user.first_name} ${user.last_name}`;
                                                                        
                                                                        const selection = window.getSelection();
                                                                        const range = selection.getRangeAt(0);
                                                                        const textNode = range.startContainer;
                                                                        const text = textNode.textContent;
                                                                        const cursorPos = range.startOffset;
                                                                        const atIndex = text.lastIndexOf('@', cursorPos - 1);
                                                                        
                                                                        range.setStart(textNode, atIndex);
                                                                        range.setEnd(textNode, cursorPos);
                                                                        range.deleteContents();
                                                                        range.insertNode(mentionSpan);
                                                                        
                                                                        const spaceNode = document.createTextNode(' ');
                                                                        mentionSpan.parentNode.insertBefore(spaceNode, mentionSpan.nextSibling);
                                                                        
                                                                        range.setStart(spaceNode, 1);
                                                                        range.setEnd(spaceNode, 1);
                                                                        selection.removeAllRanges();
                                                                        selection.addRange(range);
                                                                        
                                                                        setShowMentionDropdown(false);
                                                                        setMentions(prev => [...prev, {
                                                                            start: atIndex,
                                                                            end: atIndex + `@${user.first_name} ${user.last_name}`.length,
                                                                            name: `${user.first_name} ${user.last_name}`,
                                                                            userCode: user.id
                                                                        }]);
                                                                    }
                                                                    return;
                                                                }
                                                                
                                                                if (e.key === 'Enter' && !e.shiftKey && !showMentionDropdown && !sendingSms) {
                                                                    e.preventDefault();
                                                                    handleSendMessage();
                                                                }
                                                            }}
                                                            className={`py-5 leading-[1.6rem] h-[68px] max-h-[120px] overflow-y-auto scrollBar outline-none border border-transparent focus:border focus:border-p_primary w-full pl-4 pr-[100px] bg-background_blue rounded-[8px] resize-none relative z-1 ${ticketDetails?.status === "Closed" ? 'cursor-not-allowed' : ''}`}
                                                            data-testid="msg-input"
                                                        >
                                                        </div>
                                                            {(!inputMessage || inputMessage.trim() === '') && (
                                                                <span className="text-gray-400 absolute top-5 left-4 pointer-events-none z-0 leading-[1.6rem]">
                                                                    {ticketDetails?.status === "Closed" ? "This ticket is closed" : !isUserAssigned ? "You are not assigned to this ticket" : "Type a message"}
                                                                </span>
                                                            )}

                                                        {/* Mention dropdown - only show in internal mode */}
                                                        {showMentionDropdown && messageType === 'internal' && (
                                                            <MentionDropdown
                                                                users={mentionUsers}
                                                                selectedIndex={selectedMentionIndex}
                                                                onSelect={handleMentionSelect}
                                                                loading={loadingMentions}
                                                            />
                                                        )}
                                                        {/* Hidden file input */}
                                                        <input
                                                            ref={fileInputRef}
                                                            type="file"
                                                            id="file-upload"
                                                            className="hidden"
                                                            accept=".pdf,.jpg,.jpeg,.png,.mp4,.mov"
                                                            onChange={handleFileChange}
                                                        />

                                                        {/* Trigger icon for upload */}
                                                        <label htmlFor="file-upload">
                                                            <Image
                                                                src="paperclip"
                                                                className={`absolute top-[24px] right-[64px] ${isInteractionDisabled ? 'pointer-events-none opacity-50 cursor-not-allowed' : 'cursor-pointer'
                                                                    }`}
                                                            />
                                                        </label>

                                                        {/* Mic icon */}
                                                        <Image
                                                            src="mic"
                                                            className={`absolute top-[24px] right-[24px] ${isInteractionDisabled ? 'pointer-events-none opacity-50 cursor-not-allowed' : 'cursor-pointer'
                                                                }`}
                                                            onClick={!isInteractionDisabled ? startRecording : undefined}
                                                        />
                                                    </div>

                                                </div>
                                                {/* Send Button */}
                                                <div
                                                    className={`p-3 mb-3  rounded-[8px] cursor-pointer h-fit ${isRecording || isUploadingFile || sendingSms || !isUserAssigned ? 'bg-gray-300 pointer-events-none' : 'bg-p_primary'}`}
                                                    onClick={!isRecording && !isUploadingFile && !sendingSms && isUserAssigned ? handleSendMessage : undefined}
                                                >
                                                    <Image src="send" className="w-fit h-fit" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>

                        {/* Ticket Management Section */}
                        <div className="flex flex-col gap-4 mt-4  w-[40%] lg:w-[35%] xl:w-[25%] overflow-y-auto h-ticketViewHeight">
                            <div className='border  p-4  rounded-lg'>
                                <p className="text-heading4 mb-2 border-b pb-1 font-medium">Ticket Management</p>


                                <DropdownButtonForSearch
                                    options={assigneeOptions.map(a => a.label)}
                                    labelName="Assignee"
                                    id="ticket-assignee"
                                    onChange={(id, value) => {
                                        const selected = assigneeOptions.find(a => a.label === value);
                                        if (selected) setAssignee(selected);
                                    }}
                                    selectedValue={assignee?.label}
                                    width='w-full'
                                    placeholder="Select Assignee"
                                    loadMoreOptions={fetchAssignees}
                                    loading={loadingAssignees}
                                    editLoading={false}          // Only for shimmer (initial load, not search)
                                    modalStyle="w-full"
                                    className='mb-2'
                                    testId="ticket-assignee-dropdown"
                                    disabled={ticketDetails?.status === "Closed"}
                                    alwaysShowIndicator={true}
                                />


                                <DropdownButtonForSearch
                                    options={PriorityLevel}
                                    labelName="Priority"
                                    width='w-full'
                                    id="ticket-priority"
                                    noSearch
                                    onChange={(id, value) => setPriority(value)}
                                    selectedValue={priority}
                                    placeholder="Select Priority"
                                    modalStyle="w-full"
                                    testId="ticket-priority-dropdown" tabIndex={0}
                                    disabled={ticketDetails?.status === "Closed"}
                                    alwaysShowIndicator={true}
                                />


                                <Button
                                    buttonName={'Assign'}
                                    buttonWidth='w-full'
                                    buttonHight='h-[45px]'
                                    className='mt-2'
                                    buttonDisabled={
                                        ticketDetails?.status === "Closed" ||
                                        !priority ||
                                        !assignee ||
                                        (priority === originalPriority && assignee?.id === originalAssignee?.id)
                                    }
                                    buttonOnclick={() => handleTicketUpdate("assign")}
                                    loading={actionLoading === "assign"}
                                />
                            </div>
                            {/* Quick Action */}
                            {assignee && priority && ticketDetails?.status !== "Closed" && isUserAssigned ? (
                                <div className="p-4 border rounded-lg text-primary_text text-subTitle flex flex-col justify-center items-center">
                                    <p className='border-b w-full pb-2.5'>Quick Action</p>
                                    <div className='w-full pt-4'>
                                        <Button
                                            buttonName={'Close Ticket'}
                                            buttonWidth='w-full'
                                            buttonHight='h-[45px]'
                                            className='mt-2 border disabled:bg-white bg-white disabled:text-disable_text
 disabled:border-disable_stroke border-p_primary'
                                            buttonDisabled={ticketDetails?.status === "Closed" || !priority || !assignee}
                                            textColor='disabled:text-disable_stroke text-p_primary'
                                            textSize='font-semibold'
                                            loading={actionLoading === "close"}
                                            buttonOnclick={() => setShowCloseConfirmModal(true)}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="h-[200px]" />
                            )}
                        </div>
                    </div>
                </div>
            </AddModel>

            {showModal && (
                <ViewTicketModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    ticketDetails={ticketDetails}
                    userCode={userInfo?.user_code || '-'}
                />
            )}

            <CustomModal
                isOpen={showCloseConfirmModal}
                onClose={() => setShowCloseConfirmModal(false)}
                title="Close Ticket"
                subText={`You are about to close ticket ID ${ticketDetails?.ticket_id || 'TT100'}. Are you sure you want to proceed?`}
                primaryButtonText="Close"
                secondaryButtonText="Cancel"
                primaryButtonClassName='w-[96px] font-semibold'
                handelSubmit={() => {
                    setShowCloseConfirmModal(false);
                    handleTicketUpdate("close");
                }}
                buttonLoading={actionLoading === "close"}
            />
        </div>
    )
}

export default ViewTicket
